export default "__VITE_ASSET__CIH5nHWa__"